module.exports = __webpack_public_path__ + "static/media/account.9380aad1.svg";